import { Routes } from '@angular/router';
import { authGuard } from '../guard/auth.guard';
import { geoLevelGuard } from '../guard/role.guard';
import { MetabaseDashboardGraphComponent } from '../reports/metabase-dashboard-graph/metabase-dashboard-graph.component';
import { MetabaseReportComponent } from '../reports/metabase-report/metabase-report.component';

export const reportsRoutes: Routes = [
    {
        path: 'reports/pg-summary',
        loadComponent: () => import('../reports/pg-summary/pg-summary.component').then((m) => m.PgSummaryComponent),
        canActivate: [authGuard]
    },
    {
        path: 'reports/chc-summary',
        loadComponent: () => import('../reports/chc-summary/chc-summary.component').then((m) => m.ChcSummaryComponent),
        canActivate: [authGuard]
    },
    {
        path: 'reports/pe-summary',
        loadComponent: () => import('../reports/pe-summary/pe-summary.component').then((m) => m.PESummaryComponent),
        canActivate: [authGuard, geoLevelGuard(['state', 'national'])]
    },
    {
        path: 'reports/cluster-summary',
        loadComponent: () =>
            import('../reports/cluster-summary/cluster-summary.component').then((m) => m.ClusterSummaryComponent),
        canActivate: [authGuard]
    },
    {
        path: 'reports/eep-summary',
        loadComponent: () => import('../reports/eep-summary/eep-summary.component').then((m) => m.EepSummaryComponent),
        canActivate: [authGuard]
    },
    {
        path: 'reports/incubator-summary',
        loadComponent: () =>
            import('../reports/incubator-summary/incubator-summary.component').then((m) => m.IncubatorSummaryComponent),
        canActivate: [authGuard, geoLevelGuard(['state', 'national'])]
    },
    {
        path: 'expenditure-status-meta/:reportId/:reportName',
        component: MetabaseReportComponent,
        canActivate: [authGuard]
    },
    {
        path: 'dashboard-graph-meta/:reportId/:reportName',
        component: MetabaseDashboardGraphComponent,
        canActivate: [authGuard]
    }
];
